import { stringInArray } from "./string.utils";
function flattenObject(obj, parentKey = "", result = {}) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof obj[key] === "object" &&
                obj[key] !== null &&
                !Array.isArray(obj[key])) {
                this.flattenObject(obj[key], newKey, result);
            }
            else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}
function isKeyRecord(obj) {
    return obj && typeof obj === "object" && "key" in obj;
}
export const merge = (state, newState) => {
    // let cloneState = { ...state };
    // let cloneNewState = { ...newState };
    const cloneState = JSON.parse(JSON.stringify(state));
    const cloneNewState = JSON.parse(JSON.stringify(newState));
    delete cloneState["key"];
    delete cloneNewState["key"];
    return deepMerge(cloneState, cloneNewState);
    // return {
    //     ...cloneState,
    //     ...cloneNewState,
    // };
};
export const deepMerge = (target, source) => {
    if (typeof target !== "object" || target === null) {
        return source;
    }
    if (typeof source !== "object" || source === null) {
        return target;
    }
    const merged = Object.assign({}, target);
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            // console.log(key, source[key]);
            if (typeof source[key] === "object" && source[key] !== null) {
                if (!target[key]) {
                    merged[key] = source[key];
                }
                else {
                    merged[key] = deepMerge(target[key], source[key]);
                }
            }
            else {
                if (source[key] !== "") {
                    merged[key] = source[key];
                }
                else {
                    // if value is empty, remove key
                    delete merged[key];
                }
            }
        }
    }
    return merged;
};
export const deepClone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
export const retainSpecifiedKeys = (currentState, propsRemove) => {
    const newState = Object.assign({}, currentState);
    for (const key in newState) {
        if (newState.hasOwnProperty(key)) {
            if (!stringInArray(key, propsRemove)) {
                delete newState[key];
            }
        }
    }
    return newState;
};
export const removeKeysFromObj = (currentState, propsRemove) => {
    const newState = Object.assign({}, currentState);
    propsRemove.forEach((prop) => {
        delete newState[prop];
    });
    return newState;
};
export function clear(j) {
    console.log("clear", j);
    // if (j && j.key && this.map.has(j.key)) {
    //     this.map.delete(j.key);
    // } else {
    //     if (j) {
    //         let values = this.map.get(getCurrentExperience());
    //         let updated = this.clearStateProps(values, j as string[]);
    //         this.map.set(getCurrentExperience(), updated);
    //     } else {
    //         if (this.map.has(getCurrentExperience())) {
    //             this.map.delete(getCurrentExperience());
    //         }
    //     }
    // }
}
// export function clearCustomStateProps = (currentState: object, propertiesToClear: string[]): object => {
//     const newState = { ...currentState };
//     for (const key in newState) {
//         if (newState.hasOwnProperty(key)) {
//             if (!stringInArray(key, this.reservedProperties)) {
//                 delete newState[key];
//             }
//         }
//     }
//     return newState;
// };



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/array.utils.js
// module id = ./node_modules/@celine/passive-tracking/dist/array.utils.js
// module chunks = 0